<div class="add-payment">
    <div class="add-payment__header" fxLayout="column" fxLayoutAlign="center center">
        <div class="add-payment__header-title">
            Check-in Not Available Yet
        </div>
        <!-- <div class="add-payment__header-close">
            <mat-icon class="close-icon" [svgIcon]="'close'" (click)="closePopup()"></mat-icon>
        </div> -->
    </div>
    <div class="add-payment__main" style="margin: 20px !important;" fxLayout="column" fxLayoutAlign="center center">
        The guest is scheduled to arrive on {{arrivalDate}}. Check-in can only be completed once the allowed check in
        window opens.
    </div>
    <div class="add-payment__summary" fxLayout="column" fxLayoutAlign="center center">
        <div class="add-payment__summary-actions" fxLayoutAlign="center center">
            <!-- <div mat-ripple class="add-payment__summary-clear" (click)="closePopup()">
                Cancel
            </div> -->
            <div mat-ripple class="add-payment__summary-show" (click)="closePopup()">
                Okay
            </div>
        </div>
    </div>
</div>